// extracted by mini-css-extract-plugin
export default {"subText":"GoogleButton_subText__q+ROC","label":"GoogleButton_label__MOKOQ","google":"GoogleButton_google__IdcAy","text":"GoogleButton_text__fZhta"};